import classNames from "classnames";

import { useCheckoutConfiguration } from "@jti/commerce/providers";
import type { IMoney, Tax } from "@jti/magento";
import { useSelector } from "@jti/store/reduxHooks";
import { useTranslations } from "@jti/ui";

import { PriceBlock } from "../PriceBlock/PriceBlock";

import styles from "../Prices.module.scss";

type TrialsPricesType = {
  currency: string;
  deposit: IMoney | number;
  subtotal: IMoney | number;
  shipping: IMoney | number;
  total: number;
  discount: number;
  totalNowTax: Tax[];
  totalAfterTrialInclTax: number;
  totalAfterTrialTax: Tax[];
  isSummary?: boolean;
  className?: string;
};

const getTrialPriceValue = (value: IMoney | number): number => {
  return typeof value === "object" ? value.value : value;
};

export const TrialsPrices = ({
  currency,
  shipping,
  totalNowTax,
  totalAfterTrialInclTax,
  totalAfterTrialTax,
  total,
  subtotal,
  deposit,
  isSummary = false,
  className,
}: TrialsPricesType) => {
  const { __ } = useTranslations();
  const { taxInfo: additionalTaxInfo } = useCheckoutConfiguration();

  const { currency: shopCurrency } = useSelector((state) => state.cart);

  return (
    <>
      <div className={classNames(styles.pricesColumns, className)}>
        <PriceBlock
          testId="cartSubtotal"
          currency={currency}
          shopCurrency={shopCurrency}
          value={getTrialPriceValue(subtotal)}
          title={__("cart.prices.subtotal")}
        />

        <PriceBlock
          testId="cartTrialDeposit"
          currency={currency}
          shopCurrency={shopCurrency}
          value={getTrialPriceValue(deposit)}
          title={__("cart.prices.trial.deposit")}
        />

        <PriceBlock
          testId="cartShipping"
          currency={currency}
          shopCurrency={shopCurrency}
          value={getTrialPriceValue(shipping)}
          title={__("cart.prices.shippingCharges")}
        />
      </div>
      <PriceBlock
        testId="cartTotalNow"
        currency={currency}
        shopCurrency={shopCurrency}
        value={total}
        title={__("cart.prices.totalNow.title")}
        subtitle={!isSummary ? "" : __("cart.prices.total.deposit")}
        totalTitle={true}
        isSummary={isSummary}
        tax={totalNowTax}
        taxInfo={additionalTaxInfo}
        topSeparator={true}
      />
      <PriceBlock
        testId="cartTotalAfterTrials"
        currency={currency}
        shopCurrency={shopCurrency}
        value={totalAfterTrialInclTax}
        tax={totalAfterTrialTax}
        taxInfo={additionalTaxInfo}
        title={__("cart.prices.totalAfterTrial")}
        topSeparator={true}
      />
    </>
  );
};
